import { compact, groupBy, sortBy } from 'lodash';
import { ProcessedRevaluation } from '../../helpers/processRevaluationHistory';

export default function getLatestRevaluationsForEachHoldingClass(
  revaluationHistory: Array<ProcessedRevaluation>,
) {
  const groupedByHoldingClass = groupBy(
    revaluationHistory,
    (rev) => rev.holdingClassId,
  );

  const latestRevaluations = Object.values(groupedByHoldingClass).map(
    (classRevaluations) => {
      const sortedRevaluations = sortBy(classRevaluations, 'ledgerDate');
      return sortedRevaluations[sortedRevaluations.length - 1];
    },
  );

  return compact(latestRevaluations);
}
